import { FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms'

export const timeValidator: ValidatorFn = (
  control: FormGroup
): ValidationErrors | null => {
  const startTime = control.get('startedAt')
  const endTime = control.get('endedAt')

  if (startTime && endTime && startTime.value && endTime.value) {
    const start = new Date(startTime.value)
    const end = new Date(endTime.value)

    if (start.getTime() >= end.getTime()) {
      return { timeError: true }
    }
  }
  return null
}
